import IdPage from './id';
import RsvpService from '../../services/RsvpService';
import { initTranslation } from '../../services/Translate';

const state = {
  	name: 'id',
  	url: '/id/:contact_uuid?{env}',
  	component: IdPage,
    resolve: [
        {
            token: 'contact',
            deps: ['$transition$'],
            resolveFn: (trans) => {
                return new RsvpService().getContact(trans.params()).then(data => {
                    return initTranslation(data.preferred_language).then(() => data);
                });
            }
        },
        {
            token: 'eventsActive',
            deps: ['$transition$'],
            resolveFn: (trans) => {
                return new RsvpService().getEventsActive(trans.params());
            }
        },
        {
            token: 'eventsPast',
            deps: ['$transition$'],
            resolveFn: (trans) => {
                return new RsvpService().getEventsPast(trans.params());
            }
        }
    ]
};

export default state;